function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import compose from 'lodash/fp/compose';
import { RemotingStore } from './RemotingStore';
import * as Mixin from './mixins';

var Mixins = compose(Mixin.Reading, Mixin.Reloading, Mixin.Selecting);

export var ReloadingStore = function (_Mixins) {
  _inherits(ReloadingStore, _Mixins);

  function ReloadingStore() {
    _classCallCheck(this, ReloadingStore);

    return _possibleConstructorReturn(this, _Mixins.apply(this, arguments));
  }

  return ReloadingStore;
}(Mixins(RemotingStore));